import React from 'react';
import { observer } from 'mobx-react-lite';
import add_cart_cancel from '@assets/img/add_cart_cancel.png';
import add_cart_done from '@assets/img/add_cart_done.png';

const AddCartTips = observer(({ added }) => {
  return (
    <div
      className={[
        //'absolute left-0 bottom-0px transform translate-y-[calc(100%+18px+24px)]',
        'px-10px h-32px flex items-center bg-opacity-6',
        'border-1px border-opacity-70 rounded-12px',
        added
          ? 'text-[#33C481] bg-[#33C481] border-[#33C481]'
          : 'text-[#FF3B30] bg-[#FF3B30] border-[#FF3B30]',
      ]}
    >
      <img
        src={added ? add_cart_done : add_cart_cancel}
        className={['size-16px']}
        alt=""
      />
      <div className="ml-6px text-13px font-bold">
        {added ? '您已确认将所勾选的商品加入购物车，我将开始为您逐一添加' : '您已确认取消将以上商品加入购物车，我将结束当前任务'}
      </div>
    </div>
  );
});
export default AddCartTips;
